/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import Table from 'react-toolbox/lib/table';
import { list2 } from '~/actions/articles';
import { Button } from 'react-toolbox/lib/button';
import Spinner from '~/components/Spinner';

import style from './style.scss';


const tableHeaders = {
  sku: { type: String },
  image: { type: 'iamge' },
  name: { type: String },
  upc: { type: String },
  weight: { type: String },
};

class Articles extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { loading: true, results: [], query: '' };
  }

  componentDidMount() {
    this.search();
  }

  getRows() {
    return this.state.results
      .reduce((s, v) => this.props.items[v] ? [...s, this.props.items[v]] : s, [])
      .map(item => ({
        ...item,
        image: <img className={style.image} src={item.image} alt="" />,
        weight: item.weight ? `${item.weight} g` : '',
      }));
  }

  search() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query)
      .then(r => this.setState({
        results: r.data.results.map(i => i.id),
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  loadMore() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, this.state.skipId)
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const rows = this.getRows();
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Articles</div>
        <Button
          label="New Article"
          onClick={() => this.context.dialogPush('articleNew', { onCreate: () => this.search() })}
          primary
          raised
          className={style.buttonNew}
          icon="add"
        />
        <Button
          label="Move article"
          onClick={() => this.context.dialogPush('articleMove')}
          primary
          raised
          className={style.buttonMove}
          icon="compare_arrows"
        />
        <Button
          label="Verify stock"
          onClick={() => this.context.dialogPush('verifyStock')}
          primary
          raised
          className={style.buttonVerify}
          icon="compare_arrows"
        />
        <form onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            placeholder="Search Name, UPC, SKU or ID"
            className={style.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value, skipId: null })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        {this.state.results.length === 0 && !this.state.loading ? 'No article in stock'
          : <Table
            model={tableHeaders}
            selectable={false}
            source={rows}
            onRowClick={i => this.context.dialogPush('article', { id: rows[i].id })}
            className={style.table}
          />
        }
        {this.state.loading && <Spinner className={style.spinner} />}
        {!this.state.loading && this.state.more && <Button
          label="Load more"
          disabled={this.state.loading}
          primary
          raised
          onClick={() => this.loadMore()}
          className={style.buttonLoadMore}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['articles', 'articles']).toJS(),
});

export default connect(mapStateToProps)(Articles);



// WEBPACK FOOTER //
// ./app/pages/Articles/index.js